import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/56988247608"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea por WhatsApp"
      className="fixed right-5 bottom-5 z-50 bg-[#25D366] hover:bg-[#1de9b6] p-4 rounded-full shadow-lg transition-all duration-500 ease-in-out transform"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 32 32"
        fill="white"
      >
        {/* Icono de WhatsApp */}
        <path d="M16.004 2.403c-7.45 0-13.515 6.062-13.515 13.515 0 2.384.627 4.707 1.816 6.75l-1.917 7.004 7.178-1.883a13.447 13.447 0 006.438 1.605c7.45 0 13.514-6.063 13.514-13.514S23.455 2.403 16.004 2.403zm0 24.724a11.13 11.13 0 01-5.658-1.545l-.405-.24-4.261 1.116 1.137-4.152-.265-.425a11.132 11.132 0 01-1.74-6.004c0-6.135 4.996-11.13 11.13-11.13 6.135 0 11.13 4.995 11.13 11.13s-4.996 11.13-11.13 11.13zm6.086-8.275c-.332-.168-1.961-.969-2.266-1.08-.305-.112-.527-.168-.75.169-.224.336-.861 1.08-1.055 1.304-.194.224-.388.25-.72.084-.332-.169-1.403-.516-2.67-1.645-.986-.88-1.65-1.969-1.843-2.3-.194-.336-.021-.517.147-.686.15-.148.336-.388.504-.582.167-.194.224-.336.336-.56.111-.224.056-.42-.028-.583-.083-.168-.749-1.804-1.027-2.47-.27-.648-.544-.56-.748-.56-.194 0-.416-.028-.639-.028-.224 0-.583.084-.889.42s-1.167 1.14-1.167 2.773c0 1.633 1.194 3.208 1.361 3.431.167.224 2.349 3.58 5.694 5.021.796.343 1.416.547 1.899.7.797.252 1.521.216 2.091.131.637-.095 1.961-.799 2.238-1.569.278-.77.278-1.429.194-1.57-.083-.14-.305-.223-.637-.391z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
